export const NAME = 'employees';
